import React from "react";
import { Link, NavLink } from "react-router-dom";
import TagManager from 'react-gtm-module';
import { getImgUrl, isMobile } from "../../Utility/Utility";
import { Img } from "../../Components/UI/UI";
import "./Footer.css";

const Footer = () => {
  const Interests = (e) => {
    e.preventDefault();
    TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'Interests',}});
    // window.open(
    window.location.replace("https://agents.israel.travel#chose-interest");
    
  };
  const Home = (e) => {
    e.preventDefault();
     TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'Home',}});
    // window.open(
    window.location.replace("https://agents.israel.travel");
  };
  const TravelPlanings = (e) => {
    e.preventDefault();
     TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'Travel Planings',}});
    // window.open(
    window.location.replace("https://agents.israel.travel#travel-planning");
  };
  const IsraelTravel = (e) => {
    e.preventDefault();
     TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'Israel Travel',}});
    // window.open(
    window.location.replace("https://israel.travel/");
  };
  const ContactUs = (e) => {
    e.preventDefault();
     TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'Contac tUs',}});
    // window.open(
    window.location.replace("https://agents.israel.travel/Pages/ContactUs");
  };
  const SignUp = (e) => {
    e.preventDefault();
     TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'Sign Up',}});
    // window.open(
    window.location.replace("https://agents.israel.travel#form");
  };
  const TouristBoards = (e) => {
    e.preventDefault();
     TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'Tourist Boards',}});
    // window.open(
    window.location.replace("https://agents.israel.travel#icon-info");
  };
  // const Resources = (e) => {
  //   e.preventDefault();
  //   window.open(
  //     "https://agents.israel.travel/Pages/InterestsChristian#resources"
  //   );
  // };
  // const Gallery = (e) => {
  //   e.preventDefault();
  //   // window.open(
  //   window.location.replace("https://agents.israel.travel/Pages/Gallery");
  // };
  const Faq = (e) => {
    e.preventDefault();
     TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'Faq',}});
    // window.open(
    window.location.replace("https://agents.israel.travel/Pages/FAQ");
  };
  const Covid = (e) => {
    e.preventDefault();
     TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'Covid',}});
    // window.open(
    window.location.replace(
      "https://corona.health.gov.il/en/abroad/arriving-by-air/"
    );
  };
  const GuaranteedDepartures = (e) => {
    e.preventDefault();
     TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'Guaranteed Departures',}});
    // window.open(
    window.location.replace(
      "https://agents.israel.travel/Pages/InterestsChristian#guaranteed-departures"
    );
  };
  return (
    <footer className="Footer-outer-wrapper">
      <div className="container">
        <div className="ac-footerrow ac-footerrow-1">
          <div className="ac-footercol ac-footercol-1">
            <Img desktopImg="logo.svg" imgCss="ac-footer-logo" />
            {/* <p className="ac-il-ministry-of-tourism">
              <span>ISRAEL MINISTRY OF TOURISM</span>
              <br />
              This W-learning program was developed to equip you with
              <br />
              as much as possible about Israel, in order to
              <br />
              be able to give your clients the best service.
            </p> */}
            <div className="ac-footersocial">
              <a
                href="https://www.facebook.com/goisrael"
                aria-label="facebook"
                target="_blank"
                className="ac-facebook-link ac-icon-twitter"
              >
                <span className="ac-screen-reader-only">facebook</span>
              </a>
              {/* <a
                href="https://twitter.com/israeltourism"
                aria-label="twitter"
                target="_blank"
                className="ac-twitter-link"
              >
                <span className="ac-screen-reader-only">twitter</span>
              </a> */}
              <a
                href="https://www.youtube.com/channel/UClnfG0wryFSVWcmkQ_VCFTw"
                target="_blank"
                aria-label="youtube"
                className="ac-youtube-link"
              >
                <span className="ac-screen-reader-only">youtube</span>
              </a>
              <a
                href="https://www.flickr.com/photos/israelphotogallery/sets/"
                target="_blank"
                aria-label="flickr"
                className="ac-flickr-link"
              >
                <span className="ac-screen-reader-only">flickr</span>
              </a>
              <a
                href="https://www.instagram.com/visit_israel/"
                target="_blank"
                aria-label="instagram"
                className="ac-instagram-link"
              >
                <span className="ac-screen-reader-only">instagram</span>
              </a>
            </div>
          </div>
          <div className="ac-footercol ac-footercol-2">
            <div className="ac-innerfootercol ac-innerfootercol-1 hideonMobile">
              <ul>
                {/* <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={Home}
                >
                  Home
                </NavLink> */}
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={Interests}
                >
                  Interests
                </NavLink>
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={TravelPlanings}
                >
                  Travel Planning
                </NavLink>
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={IsraelTravel}
                >
                  Israel Travel
                </NavLink>
                {/* <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={Resources}
                >
                  Resources
                </NavLink> */}
              </ul>
              <ul>
                {/* <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={GuaranteedDepartures}
                >
                  Guaranteed Departures
                </NavLink> */}
                {/* <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={Gallery}
                >
                  Gallery
                </NavLink> */}
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={Faq}
                >
                  FAQ
                </NavLink>
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={ContactUs}
                >
                  CONTACT US
                </NavLink>
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={SignUp}
                >
                  SIGN UP
                </NavLink>
                {/* <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={TouristBoards}
                >
                  Tourist Boards
                </NavLink> */}
                {/* <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={Covid}
                >
                  Info on the Covid-19
                </NavLink> */}
              </ul>
            </div>
            <div className="ac-innerfootercol ac-innerfootercol-1 hideonDesktop">
              <ul>
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={Home}
                >
                  Home
                </NavLink>
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={Interests}
                >
                  Interests
                </NavLink>
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={TravelPlanings}
                >
                  Travel Planning
                </NavLink>
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={IsraelTravel}
                >
                  Israel Travel
                </NavLink>
                {/* <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={Resources}
                >
                  Resources
                </NavLink> */}

                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={GuaranteedDepartures}
                >
                  Guaranteed Departures
                </NavLink>
                {/* <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={Gallery}
                >
                  Gallery
                </NavLink> */}
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={Faq}
                >
                  FAQ
                </NavLink>
                <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={TouristBoards}
                >
                  Tourist Boards
                </NavLink>
                {/* <NavLink
                  id="menu-travelP"
                  to=""
                  className="ac_menuitems"
                  onClick={Covid}
                >
                  Info on the Covid-19
                </NavLink> */}
              </ul>
            </div>
            <div className="ac-innerfootercol ac-innerfootercol-2">
              {/* <p className="ac-il-ministry-of-tourism ac-tech-sup">
                <span>TECHNICAL SUPPORT</span>
                <br />
              </p> */}
              {/* <a href="whatsapp://send?abid=+972543898089&text=Hello!">
                <Img
                  desktopImg="whatsapp.png"
                  imgCss="ac-footer-onfp-whatssapp"
                />
                 +972 54 3898 089 
              </a> */}
              {/* <a href="mailto:support@israel.gov.il">
                <Img desktopImg="email.png" imgCss="ac-footer-onfp-mail" />
               support@israel.gov.il 
              </a> */}
            </div>
          </div>
        </div>
        <div className="ac-footerrow ac-footerrow-2">
          <div className="ac-footercol ac-footercol-1">
            <p>
              Photographers: Guy Yehieli, Adam Primer, Kfir Boltin, Linnea
              Andres, Kfir Sivan, Haim Yafim, Dana Fridlander, Refael Ben Ari,
              Itamar Greenberg, Moshik Lindbaum, Ori Ackerman
            </p>
          </div>
          <div className="ac-footercol ac-footercol-2">
            <ul>
              <li>
                <Link className="first" to="/Pages/TermsOfUse">
                  Terms Of Use
                </Link>
              </li>
              <li> | </li>
              <li>
                <Link className="first" to="/Pages/PrivacyPolicy">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js